export function initTrackerForm() {
  window.dataLayer = window.dataLayer || [];
  document.addEventListener('FormStepCompleted', onTrackFormStepCompleted);
}

const onTrackFormStepCompleted = (event) => {
  const { formName, stepLabel, formData } = event.detail;
  let formTypeName = '';

  const dataLayer = {
    event: 'skjema_interaksjon',
    skjemaNavn: formName,
    skjemaTrinn: stepLabel,
  };

  switch (formName) {
    case 'form-stepped':
      formTypeName = 'dependencyname';
      break;
    case 'Innmelding':
      formTypeName = 'membertype';
      break;
  }

  const formTypeValue = formData.get(formTypeName);
  if (formTypeValue) {
    dataLayer.skjemaType = formTypeValue;
  }

  window.dataLayer.push(dataLayer);
};
